import {
  ORDERS_REQUEST,
  ORDERS_SUCCESS,
  ORDERS_ERROR,

  ORDERS_NEW_REQUEST,
  ORDERS_NEW_SUCCESS,
  ORDERS_NEW_ERROR,

  ORDER_STATUS_REQUEST,
  ORDER_STATUS_SUCCESS,
  ORDER_STATUS_ERROR,
} from "../actions/orders";
import HTTP from "@/utils/http";
import Vue from "vue";
import { AUTH_LOGOUT } from "../actions/auth";

const state = {
  orders: [],
  orders_get_status: "",
  orders_new_status: "",
  orders_once_loaded: false,

  order_status_status: "", // запрос статуса заказа (состояние запроса)
};

const getters = {
  getOrders: state => state.orders,
  isOrdersLoading: state => state.orders_get_status === 'loading',
  isOrdersFailed: state => state.orders_get_status === 'error',
  isOrdersNewLoading: state => state.orders_new_status === 'loading',
  isOrdersNewFailed: state => state.orders_new_status === 'error',
  ordersOnceLoaded: state => state.orders_once_loaded,

};

const actions = {
  [ORDERS_REQUEST]: ({ commit, dispatch }) => {
    commit(ORDERS_REQUEST);
    HTTP({ url: "orders" })
      .then(resp => {
        commit(ORDERS_SUCCESS, resp.data);
      })
      .catch((err) => {
        commit(ORDERS_ERROR);
        if (err.status === 401) {
          dispatch(AUTH_LOGOUT);
        }
      });
  },
  [ORDERS_NEW_REQUEST]: ({ commit, dispatch }, req) => {
    return new Promise((resolve, reject) => {
      commit(ORDERS_NEW_REQUEST);
      HTTP({ url: "orders", data: req, method: "POST" })
        .then(resp => {
          commit(ORDERS_NEW_SUCCESS, req.order_id);
          resolve(resp);
        })
        .catch(err => {
          commit(ORDERS_NEW_ERROR, err);
          console.log(err);
          if (err.status === 401) {
            dispatch(AUTH_LOGOUT);
          }
          reject(err);
        });
    });
  },//ORDER_STATUS_REQUEST
  [ORDER_STATUS_REQUEST]: ({ commit, dispatch }, req) => {
    return new Promise((resolve, reject) => {
      commit(ORDER_STATUS_REQUEST);
      HTTP({ url: "orders/status", data: { "order_guid": req.order_guid }, method: "POST" })
        .then(resp => {
          commit(ORDER_STATUS_SUCCESS);
          resolve(resp);
        })
        .catch(err => {
          commit(ORDER_STATUS_ERROR, err);
          if (err.status === 401) {
            dispatch(AUTH_LOGOUT);
          }
          reject(err);
        });
    });
  },
};

const mutations = {
  [ORDERS_REQUEST]: state => {
    state.orders_get_status = "loading";
  },
  [ORDERS_SUCCESS]: (state, data) => {
    state.orders_get_status = "success";
    Vue.set(state, "orders", data);
    state.orders_once_loaded = true;
  },
  [ORDERS_ERROR]: state => {
    state.orders_get_status = "error";
    state.orders_once_loaded = true;
  },

  [ORDERS_NEW_REQUEST]: state => {
    state.orders_new_status = "loading";
  },
  [ORDERS_NEW_SUCCESS]: (state, data) => {
    state.orders_new_status = "success";
    state.orders.unshift(data);
  },
  [ORDERS_NEW_ERROR]: state => {
    state.orders_new_status = "error";
  },

  [ORDER_STATUS_REQUEST]: state => {
    state.order_status_status = "loading";
  },
  [ORDER_STATUS_SUCCESS]: (state, data) => {
    state.order_status_status = "success";
    console.log( data );
  },
  [ORDER_STATUS_ERROR]: state => {
    state.order_status_status = "error";
  },


  [AUTH_LOGOUT]: state => {
    state.orders = [];
    state.orders_get_status = "";
    state.orders_new_status = "";
    state.orders_once_loaded = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};